// src/Components/ProductCard.js
import React from "react";
import { motion } from "framer-motion";

const ProductCard = ({ product, onClick }) => {
  return (
    <motion.div
      className="bg-white rounded-xl shadow-lg overflow-hidden cursor-pointer my-10"
      whileHover={{ y: -5, boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)" }}
      onClick={onClick}
    >
      <div className="h-48 bg-green-100 flex items-center justify-center p-4">
        <motion.img
          src={product.image}
          alt={product.name}
          className="max-h-full max-w-full object-contain"
          whileHover={{ scale: 1.1 }}
          transition={{ type: "spring", stiffness: 300 }}
        />
      </div>
      <div className="p-4">
        <h2 className="text-xl font-semibold text-green-800 mb-2">{product.name}</h2>
        
        
      </div>
      <div className="bg-green-50 p-3 mt-2">
        <p className="text-green-700 text-sm font-medium">Click for details</p>
      </div>
    </motion.div>
  );
};

export default ProductCard;